import { ReactNode } from 'react';
import { Button } from '@mui/material';
import { ButtonCustom, LoadingButton, ButtonCustomCircle } from './styles';

type Params = {
    name?: string;
    selected?: boolean;
    disabled?: boolean;
    loadingBtn?: boolean;
    type?: "button" | "submit" | "reset" | undefined;
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
    children?: ReactNode;
    isWhiteOutline?: boolean;
}

export const ButtonRectangle = ({ name = "contratar", disabled = false, type = 'button', onClick, loadingBtn = false, selected = true, children }: Params) => {
    return (
        loadingBtn ?
            <LoadingButton loading variant="contained" />
            :
            <ButtonCustom selectedstyle={selected ? 'active' : 'disable'} onClick={onClick} variant={selected ? "contained" : "outlined"} size="large" color='secondary' disabled={disabled} type={type}>{name}{children}</ButtonCustom>
    );
}

export const ButtonOutlined = ({ name = "contratar", disabled = false, type = 'button', onClick, loadingBtn = false, isWhiteOutline = false }: Params) => {
    return (
        loadingBtn ?
            <LoadingButton loading variant="outlined" />
            :
            <Button
                id='btn-outlined'
                onClick={onClick}
                variant="outlined"
                size="large"
                disabled={disabled}
                type={type}
                sx={{
                    width: '100%',
                    height: {
                        xs: '2.8125rem',
                        md: '2.3rem',
                        lg: '2.8125rem'
                    },
                    borderWidth: '2px',
                    borderRadius: '5px',
                    fontWeight: 700,
                    borderColor: isWhiteOutline ? 'white' : 'primary.main',
                    color: isWhiteOutline ? 'white' : 'primary.main',
                    '&:hover': {
                        borderWidth: '2px',
                        borderColor: isWhiteOutline ? 'white' : 'primary.main',
                        opacity: isWhiteOutline ? '.8' : '1'
                    },
                    '&:disabled': {
                        borderWidth: '2px',
                        color: isWhiteOutline ? 'white' : 'primary.main',
                        borderColor: isWhiteOutline ? 'white' : 'primary.main',
                        opacity: isWhiteOutline ? '.5' : '.5'
                    }
                }}
            >
                {name}
            </Button>
    );
}

export const ButtonCircle = ({ name = "contratar", onClick, selected = true }: Params) => {
    return (
        <ButtonCustomCircle selectedstyle={selected ? 'active' : 'disable'} variant={selected ? "contained" : "outlined"} onClick={onClick}>{name}</ButtonCustomCircle>
    );
}
